import { IInternFormCheckout } from './DialogCadastrarValor';
import { formatarMonetárioParaNúmero } from '../../../../../../../../helpers/masks';
import SelecaoCondicaoParcelamentoAPI, { TCondicaoParcelasAPI, TListaParcelasAPI } from '../../../../../../../../components/SelecaoCondicaoParcelamento/SelecaoCondicaoParcelamentoAPI';
import { TListaParcelas } from '../../..';
import { useMemo } from 'react';
import useDebounce from '../../../../../../../../lib/useDebounce';

export default function FormAPrazoAPI({
  values,
  handleChangeValues
}: FormAPrazoAPIProps) {

  const valorDebounced = useDebounce(values.valor) as string;

  const maxParcelasCondicao = values.forma_recebimento?.maximo_parcelas || 0;
  const maxParcelas = values.parcelamento_maximo < maxParcelasCondicao 
    ? values.parcelamento_maximo 
    : maxParcelasCondicao;
  const taxa = values.condicao_pagamento?.taxa || 0;
  const possuiParcelas = values.forma_recebimento?.flg_possui_parcelas;
  const condicaoPagamentoId = values.condicao_pagamento?.id;
  const formaRecebimentoId = values.forma_recebimento?.id;

  const valuePagamento: TCondicaoParcelasAPI = useMemo(() => {
    return {
      maximo_parcelas: maxParcelas,
      taxa,
      parcelas: values.pagamento.parcelas ? converterParcelasParaAPI(values.pagamento.parcelas) : [],
      qtdParcelas: values.pagamento.qtdParcelas,
      intervalo: values.forma_recebimento?.intervalo ?? 0,
      condicao_pagamento_id: condicaoPagamentoId,
      forma_recebimento_id: formaRecebimentoId,
      tipo_publico: values.tipo_publico,
      codigo_publico: values.codigo_publico,
      diaVencimentoPadrao: values.diaVencimentoPadrao || 20
    }
  }, [maxParcelas, taxa, values.pagamento, values.forma_recebimento, condicaoPagamentoId])

  const handleChangeAPI = (value: TCondicaoParcelasAPI) => {
    // Converter as parcelas de volta para o formato original
    const parcelasConvertidas = converterParcelasDeAPI(value.parcelas);
    
    handleChangeValues("pagamento", {
      ...value,
      parcelas: parcelasConvertidas
    });
  };
  
  return (
    <>
      <SelecaoCondicaoParcelamentoAPI
        valorTotal={formatarMonetárioParaNúmero(valorDebounced)}
        defaultValues={valuePagamento}
        menorValorParcelamento={20}
        onChange={handleChangeAPI}
        possuiParcelas={possuiParcelas}
        isCartao={values.forma_recebimento?.flg_usa_cartao}
        isCheque={values.forma_recebimento?.flg_usa_cheque}
        permiteEdicaoVencimento={values.forma_recebimento?.permite_edicao_vencimento}
      />
    </>
  );
}

interface FormAPrazoAPIProps {
  values: IInternFormCheckout,
  handleChangeValues: (prop: keyof IInternFormCheckout, value: any) => void
}

// Função auxiliar para converter TListaParcelas para TListaParcelasAPI
const converterParcelasParaAPI = (parcelas: TListaParcelas[]): TListaParcelasAPI[] => {
  return parcelas.map((parcela, index) => ({
    numero: index + 1,
    valor: parcela.valor,
    vencimento: parcela.vencimento,
  }));
};

// Função auxiliar para converter TListaParcelasAPI para TListaParcelas
const converterParcelasDeAPI = (parcelas: TListaParcelasAPI[]): TListaParcelas[] => {
  return parcelas.map((parcela) => ({
    valor: parcela.valor,
    vencimento: parcela.vencimento,
  }));
};